import state from "./state";
import getters from "./getters";
import mutations from "./mutations";

export default {
  autoload: true, // Load store on Vue startup
  namespaced: true,
  state,
  getters,
  mutations,
};
